<template>
	<div id="app">
		<!-- <vue-confirm-dialog style="white-space: pre-line;"></vue-confirm-dialog> -->
		<component :is="this.$route.meta.layout || 'div'" v-if="!loading">
			<router-view/>
		</component>
		<div v-else>
			<div id="loader" class="app-loader">
				<span class="spinner"></span>
			</div>
		</div>	
	</div>
</template>

<script>
import Config from './apis/Config';
export default {
	name: "App",
	data() {
		return {
			loading:true,
		}
	},
	created(){
		Config.getVersion()
		.then(response => {
			if(response.data != localStorage.getItem('version') || !localStorage.getItem('constants')){
				localStorage.setItem('version',response.data);
				Config.getConstants()
				.then(response => {
					localStorage.setItem('constants',JSON.stringify(response.data));
					this.loading = false;
				});
			}else{
				this.loading = false;
			}
		});
	}
};
</script>